import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  // Show the button when user scrolls down 200px
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    }; 

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Function to scroll to top when the button is clicked
  const scrollToTop = () => {
    console.log("Scroll button clicked"); // Check if button is clicked
    window.scrollTo({ top: 0, behavior: "smooth" }); // Native smooth scroll
  };

  return (
    <div>
      {showButton && (
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 50,
            right: 60,
            backgroundColor: "#008345",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#FF0000",
            },
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
      )}
    </div>
  );
};

export default ScrollToTopButton;
